module.exports = __webpack_public_path__ + "static/media/paytm_logo.c2ec5c45.jpeg";